export default __webpack_public_path__ + "static/media/ic_empty.236d56dc.svg";